import React from "react";
import { DraggableReactTable } from "../../../shared";
import { useBundleProducts } from "../hooks";
import { Box, Typography } from "@mui/material";
import ExternalLink from "../../../assets/images/Icons/ic_external_link_black.svg";

export const BundleProducts = () => {
  const { state, onBundleProductsOrderChange } = useBundleProducts();

  const columns = React.useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "bundle_name",
        Cell: ({ value, row }) => {
          return (
            <Typography
              flexDirection="row"
              display="flex"
              alignItems="center"
              gap="8px"
              component="a"
              href={`/products/details/${row.original.id}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: "none" , color:"text.primary"}}
            >
              {value}
              <Box
                sx={{
                  background: "rgba(237, 237, 237, 1)",
                  borderRadius: 50,
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={ExternalLink}
                  alt="ext_link"
                  sx={{ width: "14px", height: "16px", top: "4px" }}
                />
              </Box>
            </Typography>
          );
        },
        disableSortBy: true,
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DraggableReactTable
        tableTitle="Bundle Products"
        columns={columns}
        data={state.bundleProducts}
        onRowOrderChange={onBundleProductsOrderChange}
        isLoading={state.loading}
        maxHeight="202px"
      />
    </React.Fragment>
  );
};
